import { ignoreRoutesHeartbeart, ignoreRoutesReleaseLock } from 'ui/data/constants/concurrencyRoutes';

const staticItems = {
  MastersByContainer: ['ProgressMilestones', 'Integrations'],
  IgnoreRoutesHeartbeart: ignoreRoutesHeartbeart,
  IgnoreRoutesReleaseLock: ignoreRoutesReleaseLock,
  FormFactoryTransactionTypes: {
    Application: 'NEW',
    Quote: 'Quote',
    Endorsement: 'END',
    Cancellation: 'CAN',
    Reinstate: 'REI',
    Policy: 'NEW',
    QuoteOffered: 'QUOTE',
    Renewal: 'REN',
  },
};

export { staticItems };
